import { FiCheckCircle } from "react-icons/fi";
import { displayActionType } from "features/Resources/Shared/helpers";
import { ActionSummaryData, ActionV2 } from "features/Resources/Shared/models";
import GreenStatusButton from "./GreenStatusButton";

export default function SentStatus({ action }: { action: ActionV2 | ActionSummaryData }) {
  return (
    <GreenStatusButton icon={FiCheckCircle}>{`${displayActionType(action)} Sent`}</GreenStatusButton>
  );
}
